import React, { Component } from "react";

const win: any = window;
const lang = win['lang']
const rtl = (lang === "ar")
const collapseHead = (collapsedState: boolean, title: string, collapseOnClick: any) => {
  return <p className={'collapse-head noselect'} onClick={() => collapseOnClick()}>
    {title}
    {!collapsedState ? <svg width="14"
      className={'rotate0'}
      height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 7L7 2L12 7" stroke="#008CFF" stroke-width="3" stroke-linejoin="round" />
    </svg>
      :
      <svg width="14"

        className={'rotate180'}
        height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 7L7 2L12 7" stroke="#008CFF" stroke-width="3" stroke-linejoin="round" />
      </svg>}
  </p>
}

const resData = {
  "status": {
    "code": "string",
    "message": "string",
    "detail": "string",
    "help": "string"
  },
  "crmServiceRequestList": [
    {
      "serviceRequest": [
        {
          "id": "string",
          "created": "created",
          "updated": "updated",
          "srNumber": "srNumber",
          "status": "status",
          "casecode": "casecode",
          "categoryEn": "categoryEn",
          "categoryAr": "categoryAr",
          "description": "description",
          "closedDate": "closedDate"
        }
      ]
    }
  ]
}
export const formModal = (changeFields: any, collapsedState: Boolean, t: any, collapseOnClick: any, resData: any) => {


  return {
    name: "ticketTable",
    title: "",
    titleClass: "",
    subTitle: t("Please_find_complaint/request_under_your_account"),
    subTitleClass: "mb-5 ",
    id: "ticketTableForm",
    formClass: "col-12 p-0",
    changeFields: changeFields,
    collapsedState: collapsedState,
    collapseText: resData?.description,
    tableClassName: 'table-dynamic-value',
    formClassName: 'modal-form-dynamic-container',
    badgePosition: rtl ? 'bottomleft': 'bottomright',
    size: 'invisible',
    rows: [
      {
        rowClass: "w-100",
        cols: [
          {
            label: "",
            itemName: "dataTable",
            type: "table",
            nullValue: "NA",
            dispalyCols: [
              t('Ticket_Number'),
              t('Complaint_Category'),
              t('Submitter_Date'),
              t('Status'),
              t('Modified_Date'),
              "",
            ],
            dispalyColsClass: [
              "col-md-1 col-sm-6",
              "col-md-2 col-sm-6",
              "col-md-1 col-sm-6",
              "col-md-1 col-sm-6",
              "col-md-2 col-sm-6",
              "col-md-1 col-sm-6",
              "col-md-2 col-sm-6",
              "col-md-2 col-sm-6",
            ],
            postfixValues: [

            ],
            disableOn: { name: "duePaymentStatus", values: ["N/A"] },
            noDataMsg: "No Data Found",
            noDataMsgClass: "formLabel",
            colClass: "col-12",
            firstCol: "",
            table: true,
            withCollapse: true,
            idCol: "serviceAccountNumber",
            data: [
              {
                // msisdn: "966560329188",
                [t('Ticket_Number')]: resData?.srNumber,

                [t('Complaint_Category')]: rtl ? resData?.categoryAr : resData?.categoryEn,
                [t('Submitter_Date')]: resData?.created,
                [t('Status')]: rtl ? resData?.statusAr :  resData?.status,
                [t('Modified_Date')]: resData?.updated,
                "": (collapsedState: boolean) => collapseHead(collapsedState, t('Description'), collapseOnClick)


              }],
          },
        ],
      },

    ],
  }
}
